import React from 'react'
import { useNavigate } from 'react-router-dom';
import { useEffect, useState } from "react";
import GetIcon from "../../../../utils/Icon";
import printerimg from "../../../../assets/print.png"
import Button from "../../../../Core/Button/Button";
import FormLayout from "../../../../Core/Layout/FormLayout";
import { useLocation } from 'react-router-dom';
import {
    useGetSupplierGroupByNameQuery

} from '../../../../store/api/supplier';
import ApiResponseBox from '../../../../Components/ApiResponseBox';
import Tab1 from "./Tab1";
import Tab2 from './Tab2';
import Attachment from '../../../../utils/Attachment';

function Supplier() {
    const location = useLocation()
    const suppliername = location.state.supplier

    const navigate = useNavigate()
    const [tab, settab] = useState(1)
    const [res, setRes] = useState(false)
    const [error, setError] = useState('');
    const [ptype, setptype] = useState("Error")
    const [showError, setShowError] = useState(false);
    const [selectedSupplier, setSelectedSupplier] = useState('');
    const [supplirGrpname, setSuppliergrpname] = useState('')
    const [selectedCompanyAccounts, setSelectedCompanyAccounts] = useState([]);
    const [isGroup, setIsGroup] = useState(0);
    const [company, setCompany] = useState([])
    const [initialData, setInitialData] = useState([]);
    const [selectedpayment, setSelectedpayment] = useState([])

    const { data, error: supplierError, isLoading } = useGetSupplierGroupByNameQuery(suppliername, {
        skip: !suppliername,
    });
    console.log(suppliername, "dfata");




    useEffect(() => {
        if (supplierError) {
            setError('Failed to fetch supplier group');
            setptype("Error");
            setShowError(true);
        } else if (data) {
            console.log(data.data.name, "fulds");
            setSelectedSupplier(data.data.parent_supplier_group);
            setSuppliergrpname(data.data.name);
            setIsGroup(data.data.is_group);
            setSelectedpayment(data.data.payment_terms);
            const accounts = data.data.accounts || [];
            setSelectedCompanyAccounts(accounts);
            setInitialData(accounts.map(item => ({
                company: item.company,
                account: item.account
            })));
        }
    }, [data, supplierError, setSelectedCompanyAccounts]);

    return (
        <>
            <FormLayout
                title="View Supplier Group"
                breadcrumbs={[
                    { label: "Supplier Group" },
                    { label: "Supplier Group List", url: "/master/suppliergroup/supplier-list" }
                ]}
                status={'hide'}
                actionButtons={
                    <>
                        <Button
                            to="/brand/create-brand"
                            className="px-2"
                            imgSrc={printerimg}
                            imgStyle={{ width: '21px' }}
                        />
                    </>
                }
            >
                <div className="" style={{ width: "100%", backgroundColor: "#fff", flexGrow: '1' }}>
                    <div className="col-12 p-0" style={{ backgroundColor: '#eff4f9' }}>
                        <div className="d-flex justify-content-between align-items-end ">
                            <ul className="nav nav-tabs" style={{ color: "white", border: "none" }}>
                                <li className="nav-item-tab-custom d-flex pb-0 align-items-end border-radius-top-corner" >
                                    <a className={tab == 1 ? "removeborder234 nav-link active-tab-custom text-white border-radius-top-corner" : "removeborder234 nav-link nav-link-tab-custom bg-white border-radius-top-corner"} onClick={() => { settab(1) }} href="javascript:void(0);">
                                        General Details{tab == 1 ? <GetIcon iconName="MdKeyboardArrowDown" size={15} /> : <GetIcon iconName="MdKeyboardArrowRight" size={15} />}
                                    </a>
                                </li>
                            </ul>
                              <Attachment doctype="Supplier Group"  docname={suppliername}  />    
                        </div>
                    </div>
                    <div className="mt-2 py-2" style={{ width: "100%", height: 'auto', backgroundColor: "#fff", flexGrow: '1' }}>
                        <div className="row d-flex justify-content-between" style={{ flexGrow: '1' }}>
                            <div className="col-12" >
                                <div className="sidebarbox m-0 px-4 py-2">
                                    <Tab1
                                        setSelectedSupplier={setSelectedSupplier}
                                        selectedSupplier={selectedSupplier}
                                        supplirGrpname={supplirGrpname}
                                        setSuppliergrpname={setSuppliergrpname}
                                        selectedpayment={selectedpayment}
                                        setIsGroup={setIsGroup}
                                        isGroup={isGroup}
                                        setSelectedpayment={setSelectedpayment}
                                    />
                                    <Tab2
                                        setSelectedCompanyAccounts={setSelectedCompanyAccounts}
                                        initialData={initialData} suppliername={suppliername}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <ApiResponseBox
                    poptype={ptype}
                    show={showError}
                    errorMessage={error}
                    onClose={() => setShowError(false)}
                />
            </FormLayout>
        </>
    )
}

export default Supplier
